<template>
  <nuttrema-layout-content-header>

    <template slot="left">
      <user-info-small-card
         v-if="_get(ProgramDetails, 'data.assigned', false)"
        :sup-title="$t('label.assigned')"
        :person-details="_get(ProgramDetails, 'data.Participant')">
      </user-info-small-card>
      <program-diet-small-card
         v-else
        :details="ProgramDetails">
      </program-diet-small-card>
    </template>

    <template slot="center">
      <slot name="center">
        <nuttrema-group-and-sort
          class="is-centered">
          <h4 v-if="_has(meta, 'section')" slot="label" class="no-padding is-uppercase is-gray">
            {{ $t(_get(meta, 'section')) }}
          </h4>
          <h4 v-if="_has(meta, 'title')" slot="content" class="content--title">
            {{ $t(_get(meta, 'title')) }}
          </h4>
        </nuttrema-group-and-sort>
      </slot>
    </template>

    <template slot="right">

      <slot name="edit" v-if="showEdit">
        <div class="content-header-item">
          <permissions-control-wrapper
             action="label.edit"
            :required-general="$PERMISSIONS_GENERAL.EDIT"
            :permissions="_get(ProgramDetails, 'meta.permissions')">
            <edit-lock-button slot="allowed" :edit.sync="options.edit" @change="updateEditValue"></edit-lock-button>
            <edit-lock-button slot="not-allowed" :lock="true"></edit-lock-button>
          </permissions-control-wrapper>
        </div>
      </slot>

      <div class="content-header-item">
        <el-dropdown class="is-align-right" trigger="click" size="small">
          <el-button size="mini">
            {{ $t('label.options') }} <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <slot name="options"></slot>

            <el-dropdown-item divided>
              <permissions-control-wrapper
                 action="label.make_program_copy"
                :required-general="$PERMISSIONS_GENERAL.COPY"
                :permissions="_get(ProgramDetails, 'meta.permissions')">
                <a slot="allowed" @click="handleShowPage(Event.SHOW_PAGE_MAKE_COPY_PROGRAM)">
                  <i class="far fa-copy"></i> {{ $t('label.make_program_copy') }}
                </a>
                <a slot="not-allowed" disabled>
                  <i class="far fa-lock"></i> {{ $t('label.make_program_copy') }}
                </a>
              </permissions-control-wrapper>
            </el-dropdown-item>

            <template v-if="_get(ProgramDetails, 'data.assigned')">
              <el-dropdown-item divided>
                <a @click="handleShowPage(Event.SHOW_PAGE_PROGRAM_REPORTS)">
                  <i class="far fa-file-pdf"></i> {{ $t('label.program_reports') }}
                </a>
              </el-dropdown-item>

              <el-dropdown-item
                :disabled="!_includes(STATUS_PROGRAM_CAN_SEND_TO_PARTICIPANT, _get(ProgramDetails, 'data.status'))">
                <a
                  v-if="_includes(STATUS_PROGRAM_CAN_SEND_TO_PARTICIPANT, _get(ProgramDetails, 'data.status'))"
                  @click="handleShowPage(Event.SHOW_PAGE_SEND_PROGRAM_TO_PARTICIPANT)">
                  <i class="far fa-paper-plane"></i> {{ $t('label.send_to_participant') }}
                </a>
                <a
                  v-else
                  disabled
                  class="is-disabled">
                  <i class="far fa-paper-plane"></i> {{ $t('label.send_to_participant') }}
                </a>
              </el-dropdown-item>

            </template>


            <el-dropdown-item divided>
              <a @click="handleShowPage(Event.SHOW_PAGE_HELP)">
                <i class="far fa-question"></i> {{ $t('label.help') }}
              </a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

    </template>
  </nuttrema-layout-content-header>
</template>

<script>
import Emitter from 'components/mixins/emitter';
import * as Event from 'constants/event';

import NuttremaLayoutContentHeader from 'components/ui/layout/nuttrema-layout-content-header';
import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';

import UserInfoSmallCard from 'components/ui/card/user-info-small-card';
import ProgramDietSmallCard from 'components/ui/card/program-diet-small-card';

import { STATUS_PROGRAM_CAN_SEND_TO_PARTICIPANT } from 'state-machine/program/status-program';

export default {
  name: 'cmpt-programs-standard-header',
  mixins: [
    Emitter,
  ],
  props: {
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
    showEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    ProgramDetails: {
      type: Object,
      required: true,
      default: null,
    },
    meta: {
      required: false,
    },
  },
  components: {
    UserInfoSmallCard,
    ProgramDietSmallCard,
    NuttremaGroupAndSort,
    NuttremaLayoutContentHeader,
  },
  data() {
    return {
      Event,
      STATUS_PROGRAM_CAN_SEND_TO_PARTICIPANT,
      options: {
        edit: false,
      },
    };
  },
  methods: {
    updateEditValue(value) {
      this.$emit('update:edit', value);
    },
    handleShowPage(event) {
      this.dispatch('LayoutSetDietDetails', event);
    },
  },
  created() {
    this.options.edit = this.edit;
  },
  watch: {
    edit(value) {
      this.options.edit = value;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/details/cmpt-programs-standard-header.vue